<template>
  <div class="comment-section">
    <div class="row mobile-p-bottom-0" v-if="discussion.type==='booking'">
      <div class="col-md-offset-3 col-md-6 created-date">
        {{ date }}
      </div>
    </div>

    <div v-if="discussion.parent">
      <div class="col-md-11 col-md-offset-1 has-replied">
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.66667 2.99967V0.333008L0 4.99967L4.66667 9.66634V6.93301C8 6.93301 10.3333 7.99967 12 10.333C11.3333 6.99967 9.33333 3.66634 4.66667 2.99967Z" fill="#2E4051"/>
        </svg>
        {{  discussion.user_name ?  discussion.user_name : 'System' }} replied to {{ discussion.parent.user_name}}, {{discussion.created_time}}
      </div>

      <div class="col-md-12 m-t-sm mobile-m-top-0">
        <div class="col-md-1"></div>
        <div class="col-md-11 called-name mobile-m-left-44 laptop-xs-left-22">
          <span class="wrote  m-left-0">{{ discussion.parent.user_wrote }} to {{ discussion.user_name }}, {{discussion.created_time}}</span>
          <p>{{ discussion.parent.user_message }}</p>
        </div>
      </div>
    </div>

    <!-- Display each discussion item -->
    <div class="col-lg-12 col-md-12 col-xs-12 mobile-p-left-0 m-top-10">
      <div class="comment-photo col-lg-2 col-md-2 col-xs-2 m-top-22">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="#FFD233"/>
          <g clip-path="url(#clip0_4047_43712)">
            <path d="M23 12V19H13.17L12.58 19.59L12 20.17V12H23ZM24 10H11C10.45 10 10 10.45 10 11V25L14 21H24C24.55 21 25 20.55 25 20V11C25 10.45 24.55 10 24 10ZM29 14H27V23H14V25C14 25.55 14.45 26 15 26H26L30 30V15C30 14.45 29.55 14 29 14Z" fill="#2E4051"/>
          </g>
          <defs>
            <clipPath id="clip0_4047_43712">
              <rect width="24" height="24" fill="white" transform="translate(8 8)"/>
            </clipPath>
          </defs>
        </svg>
        <!--              <img :src="discussion.avatar_src" width="40" height="40" class="img-circle" alt="comment" data-toggle="tooltip" data-placement="top" :data-original-title="discussion.user_name">-->
        <!--          <div class="tooltip fade top" style="top: 2399px; left: -23px; display: block;">-->
        <!--            <div class="tooltip-arrow"></div><div class="tooltip-inner">{{ discussion.user_name }}</div></div>-->
      </div>

      <span class="wrote">{{ discussion.user_wrote }},
                <span class="time">
                  {{ discussion.created_time }}</span>
              </span>

      <span class="actions m-left-5">
                <a title="Edit visibility" data-toggle="modal" data-target="#popupi" @click="addDiscussion(discussion)">
                <svg width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                </svg>
                </a>
                <span v-if="discussion.user_id != loggedUserId && !hasSeen(discussion.seen_by_ids)" data-toggle="tooltip" title="mark as seen" class="mark_as_seen circle" @click="markAsSeen"><i class="fa fa-circle-thin"></i></span>
                <span v-if="discussion.user_id != loggedUserId && hasSeen(discussion.seen_by_ids)" data-toggle="tooltip" title="seen" class="circle"><i class="fa fa-circle"></i></span>
                <span v-if="discussion.user_role!=9 && discussion.user_id == loggedUserId" data-toggle="tooltip" data-original-title="delete" class="delete-discussion" @click="deleteRow">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_51_1145)">
                  <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#2E4051"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_51_1145">
                  <rect width="24" height="24" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </span>
        </span>

      <div :class="{'customer-message':discussion.user_role==9,'user-message':discussion.user_role!=9 ,'col-lg-10 col-md-10 col-xs-10 p-all-10 subject-div mobile-left-8':true} ">
        <p>{{ convertEntities(discussion.user_message) }}</p>
        <div v-if="(discussion.images||[]).length>0">
          <ul>
            <li v-for="(image, index) in discussion.images.slice(0,4)" v-if="image.thumbnail_src && !image.isErrored" class="image-item">
              <!--                    <a data-toggle="modal" data-target="#fn_nearest" @click="openImage(discussion.discussion_id,discussion.type,image.image_id,image.group_id)">-->
              <img :src="image.thumbnail_src" @error="handleImageError(index)" />
              <!--                    </a>-->
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-12 m-top-5 mobile-m-top-0 p-left-0 ">
        <div class="col-lg-2 col-md-2 col-xs-2"></div>
        <div class=" col-lg-10 col-md-10 col-xs-10 emailed-text p-left-10 mobile-p-left-20">
          <span>
            <span>{{ discussion.type }}, </span> <!-- Display the type -->
            <span v-if="discussion.seen_by_ids.length>0">Seen by {{ discussion.seen_by_names }}</span>
            <span v-else>Comment not seen</span>
          </span>

          <div>
            <a data-toggle="modal" data-target="#popupi" class="comment-reply" v-if="loggedUserId!=9"
               @click="addDiscussion(discussion)">
              Reply
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {markDiscussionAsSeen} from "@/modules/Booking/api/BookingViewTabs";
import index from "vuex";
export default {
  name: "DiscussionTabRow",
  computed: {
    index() {
      return index
    }
  },
  props: {
    discussion: {
      type: Object,
      required: true,
    },
    loggedUserId:{
      type: Number,
      default(){
        return 0
      }
    },
    itemType: {
      type: String
    },
    date: {
      type: String
    },
    itemId: {
      type: Number
    }
  },
  methods: {
    editPopup(editId,type,parentId) {
      const title = `${type} Discussion`;
      if (this.discussion.type == "issue"){
          editId = this.discussion.complaint_id
          type = "complaint"
      }
      const url = `/booking/discussion/${editId}/send/${type.toLowerCase()}?user_action=edit_visibility&parent_id=${parentId}`;
      window.popupi(title , url);
    },
    hasSeen(seen_by_ids){
      seen_by_ids = seen_by_ids.split(",")
      return seen_by_ids.includes(this.loggedUserId)
    },
    deleteRow(){
      this.$emit("on-delete")
    },
    markAsSeen(){
      let form = new FormData();
      form.set('discussion_id', this.discussion._id);
      form.set('type', this.discussion.type);
      markDiscussionAsSeen(form,1).then(response=>{
        if (this.discussion.seen_by_ids) {
          this.discussion.seen_by_ids += "," + this.loggedUserId;
        } else {
          this.discussion.seen_by_ids = String(this.loggedUserId);
        }
      })
    },
    handleImageError(index) {
      // Use Vue.set to ensure reactivity when setting a new property
      this.$set(this.discussion.images[index], 'isErrored', true);
    },
    // deleteComment(discussion){
    //   let form = new FormData();
    //   form.set('discussion_id', discussion.discussion_id);
    //   form.set('type', discussion.type);
    //   form.set('id', discussion.booking_id);
    //   form.set('have_images', discussion.images.length>0);
    //   if(discussion.image_id)
    //     form.set('image_id', discussion.image_id);
    //   if(discussion.group_id)
    //     form.set('group_id', discussion.group_id);
    //   let vm =this
    //   deleteItemComment(form,1).then(response=>{
    //     const indexToDelete = vm.allDiscussions['type'].findIndex(
    //         (item)=>item._id === discussion._id
    //     )
    //     if(indexToDelete!==-1){
    //       vm.allDiscussions['type'].splice(indexToDelete,1)
    //     }
    //   })
    //
    // },
    addDiscussion(item =null){
         let itemType = this.itemType;
         let itemId = this.itemId;
        let parentId = item.discussion_id
        if(item.type ==='issue'){
            itemType = 'complaint';
            itemId = item.complaint_id
        }
      const capitalizedItemType = itemType.charAt(0).toUpperCase() + itemType.slice(1);
      const title = `${capitalizedItemType} Discussion`;
      const url = `/booking/discussion/${itemId}/send/${itemType}?parent_id=${parentId}`;
      window.popupi(title , url);
    },
    openImage(discussion_id,type,image_id,group_id){
      const title = `${type.toUpperCase()} Gallery`;
      const url = `/default/sliderTabs/${this.itemId}/${image_id}/${type}/${group_id}`;
      window.popupi(title , url);
    },
      convertEntities(text) {
          // Define an HTML element to convert the entities
          let el = document.createElement("textarea");
          el.innerHTML = text;
          return el.value;
      }
  }
}
</script>
<style scoped>
.customer-message,.parent-message{
  border-radius: 20px;
  background-color: #F5F5F6;
  color: #62707C;
}
.delete-discussion{
  cursor: pointer;
  padding-top: 10px;
}
.comment-reply{
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;

}
.image-item{
  display: inline-block;
  margin-right: 5px;
}
.wrote{
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color:rgba(46, 64, 81, 1);
  margin-left: 10px;
  margin-bottom: 5px;
  display: inline-block;
}
.seen_by_row{
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color:rgba(46, 64, 81, 1);
  margin-left: 7%;
  margin-top: 10px;
}
.user-message{
  padding: 8px 12px 8px 12px;
  border-radius: 20px
}

@media (max-width: 991px) {
  .mobile-m-top-0 {
    margin-top: 0px;
  }
  .mobile-left-8 {
    left: 8px;
  }
  .mobile-p-left-20 {
    padding-left: 20px;
  }
  .mobile-p-left-0 {
    padding-left: 0px;
  }
  .mobile-m-left-44 {
    margin-left: 44px;
  }
}
/* only in this case because the logo is bigger than the col*/
@media  (min-width: 500px) and (max-width: 768px)
{
  .col-xs-2
  {

    width: 11%;
    padding: 0 5px 0 10px;
  }
}
@media (max-width: 992px) {
.wrote {
  margin-left: 21px;
}}
@media (min-width: 768px) and (max-width: 992px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 992px) and (max-width: 1100px) {
  .col-lg-2 {

    width: 16%;
    padding: 0px;
  }

}
@media (min-width: 1100px) and (max-width: 1260px) {
  .col-lg-2 {
    width: 15%;
  }
}
@media (min-width: 1260px) and (max-width: 1599px) {
  .col-lg-2 {
    width: 12%;
  }
}
@media (min-width: 1600px) and (max-width: 1920px) {
  .col-lg-2 {
    width: 9%;
  }
}
@media (min-width: 1921px)  and (max-width: 2200px) {
  .col-lg-2 {
    width: 8%;
  }
}
@media (min-width: 2200px)  {
  .col-lg-2 {
    width: 6%;
  }
}
@media (max-width: 991px) {
  .mobile-p-bottom-0{
    padding-bottom: 0px !important;
  }
}
.created-date{
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: rgb(98, 112, 124);
}
</style>